import React, { useCallback } from "react"
import { Translate } from "utils/i18n-shim"
import { openDialog } from "./store"

export const useEditTaskAction = () => {
  return useCallback((task) => {
    return {
      label: <Translate value="edit" />,
      onClick: () => openDialog(task)
    }
  }, [])
}
